// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"7ac02b00","203":"3862dadd","848":"2c92ed61"}[chunkId] + ".chunk.js";
};